import ModalMixin from "@Platon/mixins/ModalMixin"
import HotkeyMixin from "@Platon/mixins/HotkeyMixin"
import EventBusMixin from "@Platon/mixins/EventBusMixin"

export default {
	mixins: [ModalMixin, HotkeyMixin, EventBusMixin]
}
